export default __webpack_public_path__ + "static/media/apple-icon-144x144.9302202f.png";